var map = {
	"./amex.svg": "e006",
	"./diners.svg": "bf93",
	"./discover.svg": "79b3",
	"./jcb.svg": "8b75",
	"./mastercard.svg": "c241",
	"./unionpay.svg": "9beb",
	"./visa.svg": "844b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ada1";